<template>
  <div class="mainContainer" v-loading="importLoading">
    <div class="nav">
      <el-form :model="searchForm" label-width="120px" :inline="true">
        <el-form-item label="委托商：">
          <el-input v-model="searchForm.customerName" size="mini" placeholder="请输入委托商" />
        </el-form-item>
        <el-form-item label="起始地：">
          <el-input v-model="searchForm.startAddressName" size="mini" placeholder="请输入起始地" />
        </el-form-item>
        <el-form-item label="目的地：">
          <el-input v-model="searchForm.endAddressName" size="mini" placeholder="请输入目的地" />
        </el-form-item>
        <el-form-item label="运输方式：">
          <el-select v-model="searchForm.transportType" size="mini" filterable style="width: 100%" placeholder="请选择运输方式">
            <el-option label='全部' value=''></el-option>
            <el-option label='公路' value='1'></el-option>
            <el-option label='水路' value='2'></el-option>
            <el-option label='联运' value='3'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="品牌：">
          <el-input v-model="searchForm.brandName" size="mini" placeholder="请输入品牌" />
        </el-form-item>
        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" class="searchBtn" @click="btnClick('add')">新增</el-button>
          <el-button size="small" type="danger" @click="btnClick('deletes')">批量删除</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end" class="exportButton">
        <div style="display: flex; justify-content: flex-end">
          <span @click="download">模板下载</span>
          <batch-import
            uploadUrl='/price/planConsignor/batchImport'
            @importSuccess="searchBtn"
            @triggerLoading="importLoading = !importLoading" />
          <span class="mr0" @click="exportData">导出数据</span>
        </div>
      </el-col>
    </el-row>
    <div class="content">
      <el-table
        ref="registerTable"
        row-key="id"
        v-loading="tableLoading"
        :data="tableData"
        style="width: 100%"
        border
        :header-cell-style="headerCellStyle"
        @selection-change="selectionChange"
        :row-style="rowStyle">
        <el-table-column type="selection" align="center" min-width="50" />
        <el-table-column label="委托商 " prop="customerName" align="center" width="200" show-overflow-tooltip/>
        <el-table-column label="运输方式" prop="transportType" align="center" width="220" :formatter="typeFormat"/>
        <el-table-column label="起始地" prop="startAddressName" align="center" />
        <el-table-column label="目的地" prop="endAddressName" align="center" width="160" />
        <el-table-column label="品牌" prop="brandName" align="center" width="180" show-overflow-tooltip />
        <el-table-column label="费用类型" prop="priceType" align="center" width="160">
          <template slot-scope="scope">
            {{getPriceType(scope.row.priceType)}}
          </template>
        </el-table-column>
        <el-table-column label="单价" prop="price" align="center" width="120"  />
        <el-table-column label="开始时间" prop="startDate" align="center" width="150" show-overflow-tooltip/>
        <el-table-column label="结束时间" prop="endDate" align="center" width="150" show-overflow-tooltip/>
        <el-table-column label="创建人" prop="createByName" align="center" width="140" />
        <el-table-column label="创建时间"  prop="createTime" show-overflow-tooltip width="150" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getCreatTime }}</template>
        </el-table-column>
        <el-table-column label="操作" width="250" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button size="mini" class="searchBtn" @click="btnClick('info', scope.row)">详情</el-button>
            <el-button size="mini" type="warning" @click="btnClick('edit', scope.row)">修改</el-button>
            <el-button size="mini" type="danger" @click="btnClick('delete', scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="monthlyYearPlanSizeChange"
          @current-change="monthlyYearPlanCurrentChange"
          :current-page.sync="searchForm.page"
          :page-size="searchForm.rows" />
      </div>
    </div>
    <!--  新增/修改  -->
    <add-Monthly-year-plan ref="addMonthlyYearPlanRef" @searchBtn="searchBtn"/>
    <!--  详情  -->
    <detail-Monthly-year-plan ref="detailMonthlyYearPlanRef"/>
  </div>
</template>

<script>
import addMonthlyYearPlan from "./components/addMonthlyYearPlan.vue";
import detailMonthlyYearPlan from "./components/detailMonthlyYearPlan.vue";
import BatchImport from "@/components/batchImport.vue";
import {formatDateTime} from "@/config/mUtils";
import {planConsignorDelete, planConsignorPageList} from "@/service/financial";
import {paramCategoryPageList} from "@/service/basicfile";

export default {
  components: {BatchImport, addMonthlyYearPlan,detailMonthlyYearPlan},
  data() {
    return {
      importLoading: false,
      searchForm: {
        page: 1,
        rows: 10,
        customerName: '',
        startAddressName: '',
        endAddressName: '',
        transportType: '',
        brandName: ''
      },
      tableLoading: false,
      tableData: [],
      headerCellStyle: {
        color: '#3B3B3B',
        'font-size': '13px',
        height: '48px',
        background: '#E8E8E8',
      },
      total: 0,
      selectedData: [],
      priceTypeOption:[]
    };
  },
  filters:{
    getCreatTime(val) {
      if (val) {
        return formatDateTime(val, 'yyyy-mm-dd hh:ii:ss');
      } else {
        return '';
      }
    },
  },
  mounted() {
    this.getPriceTypeOption()
  },
  methods:{
    typeFormat(row, column, cellValue) {
      switch (cellValue) {
        case 1:
          return '公路';
        case 2:
          return '水路';
        case 3:
          return '联运';
      }
    },
    btnClick(str, row) {
      switch (str) {
        case 'add':
          this.$refs.addMonthlyYearPlanRef.dialogOpen('新增');
          break;
        case 'edit':
          this.$refs.addMonthlyYearPlanRef.dialogOpen('修改', row);
          break;
        case 'info':
          this.$refs.detailMonthlyYearPlanRef.dialogOpen(row);
          break;
        case 'delete':
          this.deleteData(row.id);
          break;
        case 'deletes':
          if (this.selectedData.length === 0) return this.$message.warning('请选择数据后删除！');
          const deleteIds = this.selectedData.map(item => item.id)
            .join(',');
          this.deleteData(deleteIds);
          break;
      }
    },
    //查询
    searchBtn(){
      this.getTableData()
    },
    //获取数据
   async getTableData(){
      this.tableLoading = true;
      const res = await planConsignorPageList(this.searchForm)
      this.tableLoading = false;
      this.tableData = res.data.records;
      this.total = res.data.total;
    },
    //重置
    resetBtn(){
      this.searchForm ={
        customerName: '',
        startAddressName: '',
        endAddressName: '',
        transportType: '',
        brandName: ''
      }
    },
    //删除
    deleteData(ids) {
      this.$confirm('确认删除当前选中数据？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          const {
            status,
            message,
          } = await planConsignorDelete({ids});
          if (status !== 0) return this.$message.warning(message);
          this.$message.success(message);
          this.searchBtn()
        });
    },
    //模板下载
    download(){
      window.location.href = '/file/年月计划收入价格设置导入模板.xlsx';
    },
    //导出数据
    exportData(){
      window.exportExcelAllFunc({
        type:'post',
        url:'/price/planConsignor/export',
        name: '年月计划收入价格设置表'
      })
    },
    selectionChange(val) {
      this.selectedData = val;
    },
    rowStyle({ row }) {
      return this.selectedData.includes(row) ? { background: 'rgb(197 226 255)' } : {};
    },
    monthlyYearPlanSizeChange(row) {
      this.searchForm.rows = row;
      this.searchForm.page = 1;
      this.getTableData();
    },
    monthlyYearPlanCurrentChange(page) {
      this.searchForm.page = page;
      this.getTableData();
    },
    getPriceType(val) {
      for (let i = 0; i < this.priceTypeOption.length; i++) {
        if (this.priceTypeOption[i].classbName == val) {
          return this.priceTypeOption[i].classaName;
        }
      }
    },
    async getPriceTypeOption() {
      const {status, message, data} = await paramCategoryPageList({
        value: '',
        status: '',
        rows: 9999,
        Page: 1,
        classaName: '',
        states: '',
        paramId: '658625de271048b78be6f1f569211d14',
      });
      this.priceTypeOption = data.records
    }
  }
}
</script>

<style lang="scss" scoped></style>
